import React, { useState } from "react";
// import { Link} from "react-router-dom";
import { HashLink as Link } from 'react-router-hash-link';
import "./Navbar.css";
import Navbaricon from "../../static/navbaricon.svg";
import { GiHamburgerMenu } from "react-icons/gi";

const Navbar = () => {

    const [isOpen, setIsOpen] = useState(false);

    const toggleNavbar = () => {
        setIsOpen(!isOpen);
    };

    return (
        <nav className="navbar">
            <div className="navbar-container">
                <Link to="/" className="navbar-logo">

                    <img alt="sanika" src={Navbaricon} style={{ width: "70px", height: "70px", paddingRight: "10px" }} />
                    <span style={{ fontFamily: "Lilita One", fontSize: "2.5rem", fontWeight: "100" }}>Sanika Ardekar</span>
                </Link>
                <div className={`navbar-menu ${isOpen ? "active" : ""}`}>
                    <ul className="navbar-items">

                        <>
                            <li className="navbar-item" onClick={toggleNavbar}>

                                <a href="#about" className="navbar-link"> About </a>

                            </li>
                            <li className="navbar-item" onClick={toggleNavbar}>
                                
                                    <a href="#workex" className="navbar-link">Work Experience</a>
                                
                            </li>
                            <li className="navbar-item" onClick={toggleNavbar}>
                                <a href="#projects" className="navbar-link">
                                    Projects
                                </a>
                            </li>
                            <li className="navbar-item">
                               <a href="#achievements" className="navbar-link">
                                    Achievements
                                </a>
                            </li>
                            <li className="navbar-item" onClick={toggleNavbar}>
                                <a href="#research" className="navbar-link">
                                    Research
                                </a>
                            </li>
                            <li className="navbar-item" onClick={toggleNavbar}>
                                <a href="#contact" className="navbar-link">
                                    Contact-Me
                                </a>
                            </li>
                            {/* <li className="navbar-item">
                                <Link to="/Education" className="navbar-link" onClick={toggleNavbar}>
                                    Education
                                </Link>
                            </li> */}
                        </>

                    </ul>
                </div>
                <div
                    className={`navbar-toggle ${isOpen ? "active" : ""}`}

                    onClick={toggleNavbar}
                > <GiHamburgerMenu style={{ color: "white" }} /></div>
            </div>
        </nav >
    );
};

export default Navbar;